import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { getAdvanced, getMediaQueries } from '../../utils';
export default (function (node) {
  var autoplaySpeed = parseInt(node.getAttribute('data-autoplay-speed'));
  return _objectSpread({
    minHeight: node.style.minHeight,
    autoplay: node.getAttribute('data-autoplay') === 'true',
    fade: node.getAttribute('data-fade') === 'true',
    infinite: node.getAttribute('data-infinite-loop') === 'true',
    showArrows: node.getAttribute('data-show-arrows') === 'true',
    showDots: node.getAttribute('data-show-dots') === 'true'
  }, !isNaN(autoplaySpeed) && {
    autoplaySpeed: autoplaySpeed
  }, getAdvanced(node), getMediaQueries(node));
});